import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

export function Layout({ children, showHeader = true, showFooter = true, className = "" }) {
  return (
    <div className="flex flex-col min-h-screen">
      {showHeader && <Header />}
      <main className={`flex-grow ${className}`}>
        {children}
      </main>
      {showFooter && <Footer />}
    </div>
  );
}
